
const services = [
  {
    icon: 'ri-palette-line',
    title: 'Logo Design',
    description: 'Crafting unique, memorable logos that capture your brand essence and leave a lasting impression on your audience.',
  },
  {
    icon: 'ri-award-line',
    title: 'Brand Identity Systems',
    description: 'Complete brand identity solutions including color palettes, typography, and visual guidelines for consistent branding.',
  },
  {
    icon: 'ri-instagram-line',
    title: 'Social Media Creative Design',
    description: 'Eye-catching social media graphics that boost engagement and make your brand stand out in crowded feeds.',
  },
  {
    icon: 'ri-file-paper-line',
    title: 'Posters &amp; Flyers',
    description: 'Stunning print designs that communicate your message effectively and attract attention in any environment.',
  },
  {
    icon: 'ri-youtube-line',
    title: 'YouTube Thumbnails',
    description: 'Click-worthy thumbnails designed to maximize views and engagement for your YouTube content.',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'Business Cards &amp; Banners',
    description: 'Professional business materials that make powerful first impressions and elevate your brand presence.',
  },
];

export default function Services() {
  return (
    <section id="services" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 font-['Montserrat']">
            Premium <span className="text-[#fcd34d]">Services</span>
          </h2>
          <p className="text-white/60 text-lg font-['Roboto'] max-w-2xl mx-auto">
            Elevate your brand with world-class design services tailored to your unique vision
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 hover:border-[#fcd34d]/50 shadow-xl hover:shadow-2xl hover:shadow-[#fcd34d]/20 transition-all duration-500 hover:scale-105 hover:-translate-y-2 cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#fcd34d]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              
              <div className="relative z-10">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#fcd34d] to-[#facc15] rounded-2xl mb-6 shadow-lg shadow-[#fcd34d]/30 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-3xl text-[#0f172a]`}></i>
                </div>

                <h3 className="text-2xl font-bold text-white mb-4 font-['Montserrat'] group-hover:text-[#fcd34d] transition-colors duration-300">
                  {service.title}
                </h3>

                <p className="text-white/70 font-['Roboto'] leading-relaxed">
                  {service.description}
                </p>
              </div>

              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#fcd34d]/10 to-transparent rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
